/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupResponseModel
 */
export interface LookupResponseModel {
    /**
     * 
     * @type {string}
     * @memberof LookupResponseModel
     */
    lookupType: string;
    /**
     * 
     * @type {string}
     * @memberof LookupResponseModel
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof LookupResponseModel
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupResponseModel
     */
    extendedDescription?: string;
}

/**
 * Check if a given object implements the LookupResponseModel interface.
 */
export function instanceOfLookupResponseModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lookupType" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function LookupResponseModelFromJSON(json: any): LookupResponseModel {
    return LookupResponseModelFromJSONTyped(json, false);
}

export function LookupResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lookupType': json['LookupType'],
        'value': json['Value'],
        'description': !exists(json, 'Description') ? undefined : json['Description'],
        'extendedDescription': !exists(json, 'ExtendedDescription') ? undefined : json['ExtendedDescription'],
    };
}

export function LookupResponseModelToJSON(value?: LookupResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'LookupType': value.lookupType,
        'Value': value.value,
        'Description': value.description,
        'ExtendedDescription': value.extendedDescription,
    };
}

